import React from "react";
import { CalendarDays, User, AlertCircle } from "lucide-react";
import { format } from "date-fns";

const InfoPaseDeSalida = ({ paseDeSalida }) => {
  const {
    cadeteDni,
    fechaHoraSalida,
    fechaHoraRegreso,
    observacion,
    sede,
    tipo,
    estado,
    createdAt,
  } = paseDeSalida;

  const salida = format(new Date(fechaHoraSalida), "dd/MM/yyyy HH:mm");
  const regreso = format(new Date(fechaHoraRegreso), "dd/MM/yyyy HH:mm");
  const creado = format(new Date(createdAt), "dd/MM/yyyy HH:mm");

  const estadoColor =
    estado === "Finalizado" ? "text-green-500" : "text-yellow-400";

  return (
    <div className="min-h-screen flex items-center justify-center bg-black p-4">
      <div className="bg-[#1a1a1a] border-2 border-yellow-500 rounded-2xl shadow-lg max-w-xl w-full animate-pulse-slow p-6 text-white">
        
        <p className="text-lg text-center italic mb-4">
          📝 "{observacion}"
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm mb-4">
          <div className="flex items-center gap-2">
            <User size={18} className="text-gray-300" />
            <span className="text-gray-300">DNI Cadete: {cadeteDni}</span>
          </div>
          <div className="flex items-center gap-2">
            <CalendarDays size={18} className="text-gray-300" />
            <span className="text-gray-300">Creado: {creado}</span>
          </div>
          <div className="flex items-center gap-2">
            <CalendarDays size={18} className="text-yellow-400" />
            <span className="text-yellow-400">Salida: {salida}</span>
          </div>
          <div className="flex items-center gap-2">
            <CalendarDays size={18} className="text-green-400" />
            <span className="text-green-400">Regreso: {regreso}</span>
          </div>
        </div>

        <div className="flex justify-around items-center text-sm mt-4">
          <div className="flex items-center gap-2">
            <AlertCircle size={18} className={estadoColor} />
            <span className={`uppercase font-bold ${estadoColor}`}>
              {estado}
            </span>
          </div>
          <div className="text-gray-300 text-sm italic">Sede: {sede}</div>
          <div className="text-yellow-400 text-sm font-bold">{tipo}</div>
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse-slow {
          0%, 100% { box-shadow: 0 0 10px yellow; }
          50% { box-shadow: 0 0 25px yellow; }
        }

        .animate-pulse-slow {
          animation: pulse-slow 2s infinite;
        }
      `}</style>
    </div>
  );
};

export default InfoPaseDeSalida;
